import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

function mapTemplate(raw) {
  const version = raw.versions?.[0] ?? {}
  return {
    id: raw.uuid,
    mongoId: raw._id,
    name: version.title ?? '',
    description: version.description ?? '',
    summary: '',
    schema: { pages: [] },
    surveyJson: raw.surveyJson ?? version.surveyJson ?? null,
  }
}

export async function listSurveyTemplates() {
  const response = await apiClient('generic-survey').get(SURVEY_ENDPOINTS.TEMPLATES, {
    params: { page: 1, limit: 100 },
  })
  return response.data.data.map(mapTemplate)
}
